export default __webpack_public_path__ + "static/media/3TataNexonXzPlus.78ccec05.jpg";